var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { SavvyMaritalStatus, SavvyResidenceStatus, } from "@savvyinsure/savvy-auto-policy/lib/enums";
import { ApplicableDiscount } from "../components/applicable-discounts/ApplicableDiscountsForm";
import { InsuranceProducts } from "../constants";
import useAppSelector from "./useAppSelector";
export default function useDriverDiscounts(_a) {
    var _b;
    var driverData = _a.driverData, drivers = _a.drivers, policyHolder = _a.policyHolder;
    var isBundleApplicant = useAppSelector(function (state) { return state.applicant.insuranceProduct === InsuranceProducts.AutoHome; });
    var isMarried = (driverData === null || driverData === void 0 ? void 0 : driverData.maritalStatus) === SavvyMaritalStatus.Married;
    var firstDriver = drivers[0]; // this is deceptive, this can be undefined
    var hasFirstDriver = typeof (firstDriver === null || firstDriver === void 0 ? void 0 : firstDriver.id) === "string";
    var savedDiscounts = driverData === null || driverData === void 0 ? void 0 : driverData.applicableDiscounts;
    var isHomeOwner = typeof (savedDiscounts === null || savedDiscounts === void 0 ? void 0 : savedDiscounts.isHomeowner) === "boolean"
        ? savedDiscounts.isHomeowner
        : hasFirstDriver &&
            (driverData === null || driverData === void 0 ? void 0 : driverData.id) === firstDriver.id &&
            (policyHolder.residenceStatus ===
                SavvyResidenceStatus.OwnSingleFamily ||
                isBundleApplicant);
    var hasValues = savedDiscounts !== undefined && Object.values(savedDiscounts).some(Boolean);
    var checkedDiscountsByDefault = hasValues
        ? savedDiscounts
        : __assign(__assign({}, savedDiscounts), (_b = {}, _b[ApplicableDiscount.MARRIED] = isMarried, _b[ApplicableDiscount.HOMEOWNER] = isHomeOwner, _b));
    return {
        isPolicyHolder: hasFirstDriver && (driverData === null || driverData === void 0 ? void 0 : driverData.id) === firstDriver.id,
        checkedDiscountsByDefault: checkedDiscountsByDefault,
    };
}
